module.exports = __webpack_public_path__ + "img/dashboard-bg.0b950199.png";